(function () {
  function initReveal() {
    var els = document.querySelectorAll('.la-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('la-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('la-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initBurger() {
    var b = document.querySelector('[data-la-burger]');
    var m = document.querySelector('[data-la-mobnav]');
    if (!b || !m) return;
    b.addEventListener('click', function () {
      var open = m.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function initProducto() {
    var root = document.querySelector('[data-la-producto]');
    if (!root) return;
    var dataEl = root.querySelector('[data-la-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form');
    var idInput = form.querySelector('input[name=id]');
    var btn = root.querySelector('[data-la-add]');
    var priceNow = root.querySelector('[data-la-price]');
    var priceWas = root.querySelector('[data-la-was]');
    var priceOff = root.querySelector('[data-la-off]');
    var main = root.querySelector('[data-la-main]');
    var thumbs = root.querySelectorAll('[data-la-thumb]');
    var offers = root.querySelectorAll('.la-offer');
    var camsWrap = root.querySelector('[data-la-cams]');
    var cams = root.querySelectorAll('[data-la-cam]');
    var sticky = root.querySelector('[data-la-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var pastIt = !e.isIntersecting && e.boundingClientRect.top < 0;
        var before = !e.isIntersecting && e.boundingClientRect.top > 0;
        sticky.classList.toggle('is-on', pastIt || before);
      }).observe(btn);
    }
    var txtAdd = btn.getAttribute('data-add');
    var txtSold = btn.getAttribute('data-sold');
    var txtOne = camsWrap ? camsWrap.getAttribute('data-text-one') : 'Color';
    var txtMany = camsWrap ? camsWrap.getAttribute('data-text-many') : 'Color';

    function setImage(src, thumb) {
      if (src && main) { main.src = src; main.srcset = ''; }
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setImage(t.getAttribute('data-src'), t); });
    });

    function currentVariant() {
      var a = root.querySelector('.la-offer.is-active');
      var val = a ? a.getAttribute('data-value') : null;
      return variants.find(function (v) { return v.options[0] === val; });
    }

    function applyUnits(units) {
      cams.forEach(function (cam) {
        var n = parseInt(cam.getAttribute('data-la-cam'), 10);
        var show = n <= units;
        cam.hidden = !show;
        var field = cam.querySelector('[data-la-camfield]');
        field.disabled = !show;
        var label = units === 1 ? txtOne : txtMany + ' ' + n;
        cam.querySelector('[data-la-camlabel]').textContent = label;
        field.name = 'properties[' + label + ']';
      });
    }

    function update() {
      var v = currentVariant();
      if (!v) { btn.disabled = true; return; }
      idInput.value = v.id;
      priceNow.textContent = v.price_fmt;
      if (priceWas) {
        if (v.compare_fmt) { priceWas.textContent = v.compare_fmt; priceWas.hidden = false; } else { priceWas.hidden = true; }
      }
      if (priceOff) {
        if (v.off) { priceOff.textContent = v.off_text || ('-' + v.off + '%'); priceOff.hidden = false; } else { priceOff.hidden = true; }
      }
      btn.disabled = !v.available;
      btn.querySelector('span').textContent = v.available ? txtAdd : txtSold;
      applyUnits(parseInt(v.options[0], 10) || 1);
      if (sticky) {
        sticky.querySelector('[data-la-sticky-price]').textContent = v.price_fmt;
        var sw = sticky.querySelector('[data-la-sticky-was]');
        if (v.compare_fmt) { sw.textContent = v.compare_fmt; sw.hidden = false; } else { sw.hidden = true; }
        var sb = sticky.querySelector('[data-la-sticky-btn]');
        sb.disabled = !v.available;
        sb.querySelector('span').textContent = v.available ? txtAdd : txtSold;
      }
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      }
    }

    var addonWrap = root.querySelector('[data-la-addon]');
    var addonCheck = addonWrap ? addonWrap.querySelector('[data-la-addon-check]') : null;
    function placeAddon(animate) {
      if (!addonWrap) return;
      var active = root.querySelector('.la-offer.is-active');
      if (!active) return;
      active.insertAdjacentElement('afterend', addonWrap);
      addonWrap.classList.remove('is-open');
      if (animate) { void addonWrap.offsetWidth; }
      addonWrap.classList.add('is-open');
    }

    offers.forEach(function (o) {
      o.addEventListener('click', function () {
        offers.forEach(function (x) { x.classList.remove('is-active'); });
        o.classList.add('is-active');
        update();
        placeAddon(true);
      });
    });

    if (addonCheck) {
      form.addEventListener('submit', function (e) {
        if (!addonCheck.checked) return;
        e.preventDefault();
        var props = {};
        form.querySelectorAll('[data-la-camfield]').forEach(function (f) {
          if (!f.disabled) props[f.name.slice(11, -1)] = f.value;
        });
        var items = [
          { id: parseInt(idInput.value, 10), quantity: 1, properties: props },
          { id: parseInt(addonWrap.getAttribute('data-variant'), 10), quantity: 1 }
        ];
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/cart'; })
          .catch(function () { addonCheck.checked = false; btn.disabled = false; form.submit(); });
      });
    }

    cams.forEach(function (cam) {
      var field = cam.querySelector('[data-la-camfield]');
      cam.querySelectorAll('.la-sw').forEach(function (sw) {
        sw.addEventListener('click', function () {
          cam.querySelectorAll('.la-sw').forEach(function (x) { x.classList.remove('is-active'); });
          sw.classList.add('is-active');
          field.value = sw.getAttribute('data-color');
          cam.querySelector('[data-la-camcolor]').textContent = sw.getAttribute('data-color');
          var match = null;
          thumbs.forEach(function (t) { if (t.getAttribute('data-mid') === sw.getAttribute('data-mid')) match = t; });
          setImage(sw.getAttribute('data-img'), match);
        });
      });
    });

    var pre = parseInt(new URLSearchParams(window.location.search).get('color'), 10);
    if (pre && cams.length) {
      var swList = cams[0].querySelectorAll('.la-sw');
      if (swList[pre - 1]) swList[pre - 1].click();
    }
    update();
    placeAddon(false);
  }

  function initCountdown() {
    var blocks = document.querySelectorAll('[data-la-countdown]');
    if (!blocks.length) return;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var now = Math.floor(Date.now() / 1000);
      blocks.forEach(function (el) {
        var end = parseInt(el.getAttribute('data-end'), 10);
        var left = end - now;
        if (left <= 0) {
          var wrap = el.closest('.la-bf');
          if (wrap) wrap.hidden = true;
          return;
        }
        var d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
        el.querySelector('[data-d]').textContent = pad(d);
        el.querySelector('[data-h]').textContent = pad(h);
        el.querySelector('[data-m]').textContent = pad(m);
        el.querySelector('[data-s]').textContent = pad(s);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initReveal();
    initBurger();
    initProducto();
  });
})();
